import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import StdDialog from 'components/Dialogs/StdDialog';

type DialogProps = {
  title: string;
  open: boolean;
  showDlg: boolean;
  onAccept: () => void;
  onCancel: () => void;
  onShowDlgChange: (value: boolean) => void;
};

export const ApplyToExistingTxnDialog = ({
  title,
  open,
  showDlg,
  onAccept,
  onCancel,
  onShowDlgChange,
}: DialogProps) => {
  return (
    <StdDialog onClose={onCancel} open={open} showCloseButton size='md' title={title} id='apply-to-existing-txn'>
      <DialogContent sx={{ width: 516, margin: 'auto', px: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box display={'flex'} paddingBottom={1}>
          <Typography variant='bodyMedium'>
            Existing transaction updates will happen in the background, and can take some time.
          </Typography>
        </Box>
        <Typography variant='bodyRegular'>
          Until these updates finish, you may see existing transactions that have not been updated to follow your rule
          yet.
        </Typography>
        <Box sx={{ py: 4 }}>
          <Divider orientation={'horizontal'} variant={'fullWidth'} />
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Checkbox
            sx={{ pr: 1, pl: 0, py: 0 }}
            checked={showDlg}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onShowDlgChange(!!event.target.checked);
            }}
          />
          <Typography variant='paragraphRegular'>Don&apos;t show this message again</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button id='continue-with-new-rule' variant='contained' onClick={onAccept}>
          Got it
        </Button>
      </DialogActions>
    </StdDialog>
  );
};
export default ApplyToExistingTxnDialog;
